<template>
  <div class="dashboard body">
    <el-container>
      <!-- <ReportsAside /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f3']"
          @shortkey="showHiden = !showHiden"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmEdit = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <el-row class="bg-White p-3">
          <el-col :lg="6">
            <h3 style="margin: 0">تعديل الفاتوره</h3>
          </el-col>
          <el-col :lg="9"></el-col>
          <el-col :lg="3">
            <b>رقم الفاتوره : </b>
            <b>{{ sales[0].id }}</b>
          </el-col>
          <el-col :lg="6">
            <b>اسم العميل : </b>
            <b v-if="customer">{{ customer.name }}</b>
          </el-col>
        </el-row>
        <el-row class="table mt-2 px-3">
          <div
            class="el-table el-table--fit el-table--border el-table--scrollable-y el-table--enable-row-hover el-table--enable-row-transition"
            style="margin-top: 20px; height: 70vh"
          >
            <div class="el-table__header-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__header"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="25%" />
                  <col name="el-table_3_column_13" width="8%" />
                  <col name="el-table_3_column_14" width="8%" />
                  <col name="el-table_3_column_15" width="8%" />
                  <col name="el-table_3_column_16" width="8%" />
                  <col
                    name="el-table_3_column_17"
                    width="8%"
                    v-if="showHiden"
                  />
                  <col name="el-table_3_column_18" width="8%" />
                  <col
                    name="el-table_3_column_19"
                    width="8%"
                    v-if="showHiden"
                  />
                  <col name="el-table_3_column_20" width="8%" />
                </colgroup>
                <thead class="has-gutter">
                  <tr class="">
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">#</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_12 is-leaf"
                    >
                      <div class="cell">المنتج</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">الوحدة</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell">الكمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell">اضافة كمية</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell">سعر البيع</div>
                    </th>
                    <th
                      v-if="showHiden"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell">سعر الشراء</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_18 is-leaf"
                    >
                      <div class="cell center">الإجمالي</div>
                    </th>
                    <th
                      v-if="showHiden"
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_19 is-leaf"
                    >
                      <div class="cell center">الربح</div>
                    </th>
                    <th
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_20 is-leaf"
                    >
                      <div class="cell center">المتاح</div>
                    </th>
                  </tr>
                </thead>
              </table>
            </div>
            <!-- id="scrollToMe" -->
            <div
              class="el-table__body-wrapper"
              style="height: auto; max-height: 55vh"
              ref="products_table"
            >
              <table
                cellspacing="0"
                cellpadding="0"
                class="el-table__body-wrapper"
                style="height: auto; max-height: 45vh"
                ref="products_table"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="4%" />
                  <col name="el-table_3_column_12" width="25%" />
                  <col name="el-table_3_column_13" width="8%" />
                  <col name="el-table_3_column_14" width="8%" />
                  <col name="el-table_3_column_15" width="8%" />
                  <col name="el-table_3_column_16" width="8%" />
                  <col
                    name="el-table_3_column_17"
                    width="8%"
                    v-if="showHiden"
                  />
                  <col name="el-table_3_column_18" width="8%" />
                  <col
                    name="el-table_3_column_19"
                    width="8%"
                    v-if="showHiden"
                  />
                  <col name="el-table_3_column_20" width="8%" />
                </colgroup>
                <tbody class="body">
                  <tr
                    class="el-table__row"
                    v-for="(item, index) in sales[selectedIndex].products"
                    :key="index"
                    :class="
                      item.pivot.qty > item.pivot.old_qty &&
                      item.pivot.new_qty - item.pivot.old_qty > item.stock
                        ? 'bg-danger'
                        : ''
                    "
                  >
                    <template>
                      <td rowspan="1" colspan="1" class="el-table_3_column_11">
                        <div class="cell num">{{ index + 1 }}</div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_12">
                        <div class="cell">{{ item.name }}</div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_13">
                        <div class="cell">
                          {{ item.pivot.unit }}
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_14">
                        <div class="cell">
                          {{ item.pivot.old_qty }}
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_15">
                        <div class="cell">
                          <el-popover
                            :ref="item.id + '-' + item.pivot.unit_type"
                            placement="left"
                            trigger="manual"
                            content="لا يمكن ادخال كمية اقل عن ما تم بيعه"
                            v-model="item.showQtyToolTip"
                            class="bg-danger"
                            style="
                              background-color: #f56c6c !important;
                              color: #fff !important;
                            "
                          >
                          </el-popover>
                          <input
                            type="number"
                            class="form-control"
                            style="height: 40px !important"
                            min="0"
                            @change="checkValidQty(item)"
                            :class="item.showQtyToolTip ? 'error' : ''"
                            @focus="$event.target.select()"
                            v-model="item.pivot.new_qty"
                            v-popover="item.id + '-' + item.pivot.unit_type"
                          />
                          <!-- <vs-tooltip
                            top
                            shadow
                            not-hover
                            v-model="item.showQtyToolTip"
                          >
                            <template #tooltip>
                              <div class="content-tooltip">
                                لا يمكن ادخال كمية اقل من البيع
                              </div>
                            </template>
                          </vs-tooltip> -->
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_16">
                        <div class="cell">
                          <input
                            type="number"
                            class="form-control"
                            @change="calcTotal"
                            @focus="$event.target.select()"
                            v-model="item.pivot.sale_price"
                          />
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_3_column_17"
                        v-if="showHiden"
                      >
                        <div class="cell">
                          {{ item.pivot.buy_cost }}
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_18">
                        <div class="cell text-center">
                          {{
                            numberToFixed(
                              item.pivot.sale_price * item.pivot.new_qty
                            )
                          }}
                        </div>
                      </td>
                      <td
                        rowspan="1"
                        colspan="1"
                        class="el-table_3_column_19"
                        v-if="showHiden"
                      >
                        <div class="cell text-center">
                          {{
                            numberToFixed(
                              (item.pivot.sale_price - item.pivot.buy_cost) *
                                item.pivot.new_qty
                            )
                          }}
                        </div>
                      </td>
                      <td rowspan="1" colspan="1" class="el-table_3_column_20">
                        <div class="cell text-center">
                          {{ numberToFixed(item.stock) }}
                        </div>
                      </td>
                    </template>
                  </tr>
                </tbody>
              </table>
              <a id="goToBottom" href="#scrollToMe"></a>
              <div id="scrollToMe"></div>
            </div>
            <div class="el-table__footer-wrapper">
              <table
                cellspacing="0"
                cellpadding="0"
                border="0"
                class="el-table__footer"
                style="width: 100%"
              >
                <colgroup>
                  <col name="el-table_3_column_11" width="20%" />
                  <col name="el-table_3_column_12" width="14%" />
                  <col name="el-table_3_column_13" width="15%" />
                  <col name="el-table_3_column_14" width="10%" />
                  <col name="el-table_3_column_15" width="10%" />
                  <col name="el-table_3_column_16" width="10%" />
                  <col name="el-table_3_column_17" width="10%" />
                  <col name="el-table_3_column_18" width="10%" />
                </colgroup>
                <tbody class="has-gutter footer">
                  <tr>
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_11 is-leaf"
                    >
                      <div class="cell">
                        <div class="searchInput">
                          <SearchProducts
                            :allStock="false"
                            :customer="customer"
                            @selectedProduct="selectedProduct"
                            ref="searchProductsComponent"
                            @selectedProductWithBarcode="
                              selectedProductWithBarcode
                            "
                          />
                        </div>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_13 is-leaf"
                    >
                      <div class="cell">
                        <el-select
                          id="unit"
                          @input="productUnitSelected()"
                          v-model="selectedUnitId"
                          placeholder="حدد الوحدة"
                        >
                          <el-option
                            v-for="unit in productUnits"
                            :key="unit.id"
                            :label="unit.unit"
                            :value="unit.id"
                          >
                          </el-option>
                        </el-select>
                      </div>
                    </td>
                    <td
                      colspan="2"
                      rowspan="1"
                      class="el-table_3_column_14 is-leaf"
                    >
                      <div class="cell qty">
                        <el-input
                          type="number"
                          ref="qty"
                          id="qty"
                          @focus="$event.target.select()"
                          @keyup.enter.native="setPriceFocus"
                          v-model="qty"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_15 is-leaf"
                    >
                      <div class="cell sale_price">
                        <el-input
                          type="number"
                          ref="sale_price"
                          v-model="sale_price"
                          @focus="$event.target.select()"
                          @keyup.enter.native="addNewItem"
                          controls-position="right"
                        ></el-input>
                      </div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_16 is-leaf"
                    >
                      <div class="cell text-center" v-if="qty * sale_price > 0">
                        {{ qty * sale_price }}
                      </div>
                      <div class="cell text-center" v-else>-</div>
                    </td>
                    <td
                      colspan="1"
                      rowspan="1"
                      class="el-table_3_column_17 is-leaf"
                    >
                      <div class="cell text-center">
                        {{ selectedProductStock }}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </el-row>
        <el-row :gutter="10" class="footer" v-if="sales[0].products.length > 0">
          <el-col :xl="8" :lg="8" :md="18" :sm="24"
            ><div class="bg-White alignment px-3 mt-2">
              <el-row :gutter="5">
                <el-col :span="12">
                  <label for="">خصم بالقيمة</label>
                  <input
                    class="form-control"
                    @change="discountChange"
                    @focus="$event.target.select()"
                    v-model="sales[selectedIndex].discount"
                    placeholder="قيمه الخصم"
                    align="middle"
                  />
                </el-col>
                <el-col
                  :span="12"
                  v-if="sales[selectedIndex].products.length > 0"
                >
                  <label for="">خصم بالنسبة %</label>
                  <input
                    @change="percentageDiscountChange"
                    class="form-control"
                    @focus="$event.target.select()"
                    v-model="percentageDiscount"
                    placeholder="الخصم بالنسبة المئوية"
                  />
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :xl="4" :lg="4" :md="18" :sm="24"
            ><div class="bg-White alignment p-3 mt-2">
              <p>
                الكميه
                <span class="num">{{ sales[0].total_qty }}</span>
              </p>
            </div>
          </el-col>
          <el-col :xl="12" :lg="12" :md="6" :sm="24"
            ><div class="bg-White alignment mt-2">
              <p class="px-3" v-if="showHiden">
                الربح
                <span>{{
                  numberToFixed(
                    Number(sales[0].total_sale_cost) -
                      Number(sales[0].total_buy_cost)
                  )
                }}</span>
              </p>
              <p class="px-3" v-if="sales[0].products.length > 0">
                الفاتوره
                <span>{{ numberToFixed(sales[0].total_sale_cost) }}</span>
              </p>
              <p class="px-3" v-if="sales[0].discount > 0">
                بعد الخصم
                <span>{{
                  numberToFixed(sales[0].total_sale_cost - sales[0].discount)
                }}</span>
              </p>
              <el-button
                class="save"
                :disabled="disabled"
                :loading="isLoading"
                @click="confirmEdit = true"
                >حفظ الفاتوره</el-button
              >
              <el-popconfirm
                v-if="accessLinks('add_sales_return_bill')"
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                title="هل  تريد اضافة مرتجع للفاتورة ؟  "
                @confirm="goTo(`/sales/return/${sales[0].id}`)"
              >
                <el-button slot="reference" class="exit mr-3"
                  >انشاء مرتجع
                </el-button>
              </el-popconfirm>
              <el-popconfirm
                confirm-button-text="موافق"
                cancel-button-text="إلغاء"
                icon="el-icon-info"
                icon-color="red"
                title="هل تريد الرجوع للتقرير؟"
                @confirm="goTo('/sales/report')"
              >
                <el-button slot="reference" class="exit mr-3">الغاء</el-button>
              </el-popconfirm>
            </div>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div v-if="confirmEdit == true" class="dialog">
      <div class="bodySec">
        <p @click="confirmEdit = false">
          <span><i class="far fa-times-circle"></i></span> اغلاق
        </p>
      </div>
      <div class="content">
        <div class="headerSection">
          <p>الفاتوره قبل التعديل</p>
          <p class="mr-auto">
            {{ totalInvoice - this.sales[0].discount }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>الفاتورة بعد التعديل</p>
          <p class="mr-auto">
            {{
              numberToFixed(sales[0].total_sale_cost - this.sales[0].discount)
            }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>فرق الفاتوره</p>
          <p class="mr-auto">
            {{
              numberToFixed(sales[selectedIndex].total_sale_cost) -
              numberToFixed(totalInvoice)
            }}
          </p>
        </div>
        <div class="mt-2">
          <el-radio-group
            v-model="setPaied"
            style="justify-content: start !important"
          >
            <el-radio-button label="without">حفظ بدون تحصيل</el-radio-button>
            <el-radio-button @click="alert" label="paied"
              >تحصيل</el-radio-button
            >
          </el-radio-group>
        </div>
        <div v-if="setPaied == 'paied'">
          <el-row>
            <el-col> <p class="label">المبلغ المدفوع</p></el-col>
            <el-col>
              <input
                class="form-control"
                @focus="$event.target.select()"
                id="paied"
                v-model="sales[0].paied"
                @keyup.enter="editSale"
              />
            </el-col>
          </el-row>
        </div>
        <el-button
          class="mt-3 btn-green1 btn-save"
          @click="editSale"
          type="success"
          >حفظ</el-button
        >
        <el-button type="danger" @click="confirmEdit = false" class="exit mr-2"
          >الغاء</el-button
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
// import ReportsAside from "@/components/ReportsAside.vue";
import SearchProducts from "@/components/Products/SearchWithLastSalePrice";
import axiosApi from "@/plugins/axios.js";

export default {
  components: {  SearchProducts },
  name: "EditSale",
  data: () => ({
    true: true,
    showHiden: false,
    damaged_products: false,
    disabled: false,
    isLoading: false,
    false: false,
    customer: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    sale_price: "",
    min_price: "",
    qty: 1,
    active: "edit_sales",
    confirmSave: false,
    confirmEdit: false,
    totalInvoice: 0,
    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: "-",
    value: "",
    num: 1,
    ind: 0,
    selectedPorductIndex: 0,
    setPaied: "without",
    activeDelete: false,
    useParcode: false,
    autoPush: true,
    selectedIndex: 0,
    showPrice: false,
    percentageDiscount: 0,
    selectedUnitId: null,
    allowDeletePayment: false,
    showQtyToolTip: false,
    sales: [
      {
        id: "",
        inventory_id: 1,
        paied: 0,
        retuunt: 0,
        VAT: 0,
        customer: null,
        damaged_products: false,
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        discount: 0,
        total_discount: 0,
        products: [],
      },
    ],
  }),
  created() {
    if (localStorage.getItem("edited_sales")) {
      let sale_data = localStorage.getItem("edited_sales");
      this.sales = JSON.parse(sale_data);
      this.customer = this.sales[0].customer;
      this.calcTotal();
    } else {
      if (this.$route.params.id > 0) {
        this.getInvoice();
      }
    }
  },
  mounted() {
    this.scrollToEnd();
  },
  watch: {
    setPaied: function (v) {
      this.sales[0].paied = 0;
      this.sales[0].returnAmount = 0;
      if (v === "with") {
        setTimeout(() => {
          document.getElementById("paied").focus();
        }, 100);
      } else if (v === "returnAmount") {
        setTimeout(() => {
          document.getElementById("returnAmount").focus();
        }, 100);
      }
    },
  },
  methods: {
    alert() {
      alert("price clicked");
    },
    productUnitSelected() {
      this.selectedUnit = this.productUnits.filter((unit) => {
        return unit.id == this.selectedUnitId;
      })[0];
      this.sale_price = this.selectedUnit.sale_price;
      this.min_price = this.selectedUnit.min_price;
      this.selectedProductBuyCost = this.product.inventories[0].pivot.buy_cost;
      this.selectedProductStock = this.numberToFixed(
        (this.product.inventories[0].pivot.qty -
          this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package
      );
      this.selectedProductStockLabel = this.numberToFixed(
        (this.product.inventories[0].pivot.qty -
          this.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package
      );
      if (this.product.mainUnitLastInvoice != null) {
        this.selectedProductlastSaleCost = this.product.mainUnitLastInvoice.sale_price;
      } else {
        this.selectedProductlastSaleCost = "-";
      }
      setTimeout(() => {
        document.querySelector("#qty").focus();
      }, 200);
    },
    percentageDiscountChange() {
      this.sales[0].discount = Number(
        (Number(this.percentageDiscount) * this.sales[0].total_sale_cost) / 100
      ).toFixed(2);
      this.setLocalStorage();
    },
    discountChange() {
      this.percentageDiscount = Number(
        (this.sales[0].discount / this.sales[0].total_sale_cost) * 100
      ).toFixed(2);
      this.setLocalStorage();
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    getInvoice() {
      if (this.$route.params.id > 0) {
        axiosApi
          .get(`sales/${this.$route.params.id}`)
          .then((response) => {
            if (response.data.length > 0) {
              this.sales = response.data;
              this.customer = response.data[0].customer;
              this.sales[0].total_sale_cost = this.sales[0].total_cost;
              this.sales[0].discount = response.data[0].discount;
              this.sales[0].damaged_products = false;
              this.discountChange();
              let qty = 0;
              let total_sale_cost = 0;
              let total_buy_cost = 0;
              this.sales[0].products.map(function (value) {
                value["pivot"]["new_qty"] =
                  value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                qty += value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                total_sale_cost +=
                  value["pivot"]["new_qty"] * value["pivot"]["sale_price"];
                total_buy_cost +=
                  value["pivot"]["new_qty"] * value["pivot"]["buy_cost"];
                value["pivot"]["old_qty"] =
                  value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                value["showQtyToolTip"] = false;
              });
              this.sales[0].total_qty = qty;
              this.sales[0].total_sale_cost = total_sale_cost;
              this.sales[0].total_buy_cost = total_buy_cost;
              this.totalInvoice = this.sales[0].total_sale_cost;
            }
            this.checkStock();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        console.log("من فضلك حدد رقم الفاتورة أولا للبحث");
      }
    },
    showPaymentModal() {
      this.confirmSave = true;
    },
    setPriceFocus() {
      document.querySelector(".sale_price input").focus();
    },
    selectedCustomer(e) {
      this.customer = e.customer;
      this.sales[this.selectedIndex].customer = e.customer;
      this.setLocalStorage();
      document.querySelector(".productQuery input").focus();
    },
    selectedProduct(e) {
      if (e.product != null) {
        this.product = e.product;
        this.productUnits = e.product.prices;
        this.$refs.searchProductsComponent.setValue(this.product);
        this.selectedUnitId = e.product.prices[0].id;
        this.selectedUnit = e.product.prices[0];
        this.sale_price = this.selectedUnit.sale_price;
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
            this.product.units_per_package +
          " " +
          this.productUnits[0].unit;
        if (e.product.mainUnitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.mainUnitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }
        setTimeout(() => {
          document.getElementById("unit").focus();
        }, 200);
      } else {
        this.clearProduct();
      }
    },
    selectedProductWithBarcode(e) {
      this.product = e.product;
      if (this.product != null) {
        this.$refs.searchProductsComponent.setValue(this.product);
        this.productUnits = e.product.prices;
        let selectedBarcodeUnit = e.product.prices.filter((item) => {
          return item.barcode == e.barcode;
        });
        this.selectedUnit = selectedBarcodeUnit[0];
        this.selectedUnitId = selectedBarcodeUnit[0].id;
        if (this.sales[this.selectedIndex].customer.price_type == 1) {
          this.sale_price = this.selectedUnit.wholesale_price;
        } else {
          this.sale_price = this.selectedUnit.sale_price;
        }
        this.min_price = this.selectedUnit.min_price;
        this.selectedProductBuyCost = e.product.inventories[0].pivot.buy_cost;
        this.selectedProductStock =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        this.selectedProductStockLabel =
          (e.product.inventories[0].pivot.qty -
            e.product.inventories[0].pivot.hold_qty) /
          this.product.units_per_package;
        if (e.product.unitLastInvoice != null) {
          this.selectedProductlastSaleCost =
            e.product.unitLastInvoice.sale_price;
        } else {
          this.selectedProductlastSaleCost = "-";
        }
        if (this.autoPush) {
          this.qty = "1";
          this.addNewItem();
        } else {
          setTimeout(() => {
            document.querySelector("#qty").focus();
          }, 200);
        }
      } else {
        this.clearProduct();
      }
    },
    checkStock() {
      // edit-receipt/check-stock
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post(`edit-receipt/check-stock`, {
          products: this.sales[this.selectedIndex].products,
        })
        .then((res) => {
          loading.close();
          console.log("edit-receipt/check-stock", res.data);
          this.sales[this.selectedIndex].products = res.data;
          this.checkQty();
        })
        .catch(() => {
          loading.close();

          // this.$notify.error({
          //   title: "حدث خطأ",
          //   message: `عفوا المخزن المتاح لا يكفي `,
          //   duration: 1500,
          // });
        });
    },
    addNewItem() {
      if (this.qty > 0) {
        if (this.product.inventories.length == 0) {
          this.$snotify.error(` ${this.product.name} عفوا لا يوجد مخزون من `);
        } else {
          const vm = this;
          let unit_type = this.selectedUnit.type;
          var product = this.sales[0].products.filter(function (elem) {
            if (elem.id == vm.product.id && elem.pivot.unit_type == unit_type)
              return elem;
          });
          if (product.length > 0) {
            this.sales[0].products.splice(
              this.sales[0].products.findIndex(
                (e) => e.id == vm.product.id && e.pivot.unit_type == unit_type
              ),
              1
            );
            this.sales[0].products.push({
              id: product[0].id,
              name: product[0].name,
              pivot: {
                buy_cost: product[0]["pivot"].buy_cost,
                discount: 0,
                product_id: product[0]["pivot"].id,
                qty: Number(product[0]["pivot"].qty) + Number(this.qty),
                sale_price: product[0]["pivot"].sale_price,
                old_qty: product[0]["pivot"].old_qty,
                returned_qty: product[0]["pivot"].returned_qty,
                new_qty:
                  Number(product[0]["pivot"].qty) -
                  Number(product[0]["pivot"].returned_qty) +
                  Number(this.qty),
                unit: product[0]["pivot"].unit,
                unit_type: product[0]["pivot"].unit_type,
                units_per_package: product[0]["pivot"].units_per_package,
              },
              stock: product[0].stock,
              min_price: product[0].min_price,
              units_per_package: product[0]["pivot"].units_per_package,
              lastSaleCost: product[0].lastSaleCost,
              qty: Number(product[0].qty) + Number(this.qty),
            });
          } else {
            let buy_cost = 0;
            let lastSaleCost = "";
            if (this.selectedUnit.type == 1) {
              if (this.product.mainUnitLastInvoice != null) {
                lastSaleCost = this.product.mainUnitLastInvoice.sale_price;
              }
            } else if (this.selectedUnit.type == 2) {
              if (this.product.secondUnitLastInvoice != null) {
                lastSaleCost = this.product.secondUnitLastInvoice.sale_price;
              }
            } else {
              lastSaleCost = "";
            }
            let qty = 0;
            let stock = 0;
            if (this.product.inventories.length > 0) {
              qty =
                this.product.inventories[0].pivot.qty -
                this.product.inventories[0].pivot.hold_qty;
              if (this.selectedUnit.type == 1) {
                buy_cost = this.product.inventories[0].pivot.buy_cost;
                stock = Number(qty / this.product.units_per_package);
              } else {
                buy_cost =
                  this.product.inventories[0].pivot.buy_cost /
                  this.product.units_per_package;
                stock = qty;
              }
            }
            this.sales[0].products.push({
              id: this.product.id,
              name: this.product.name,
              pivot: {
                buy_cost: buy_cost,
                discount: 0,
                product_id: this.product.id,
                qty: Number(this.qty),
                old_qty: 0,
                new_qty: Number(this.qty),
                returned_qty: 0,
                sale_price: this.sale_price,
                unit: this.selectedUnit.unit,
                unit_type: this.selectedUnit.type,
                units_per_package: this.product.units_per_package,
              },
              units_per_package: this.product.units_per_package,
              stock: stock,
              min_price: this.min_price,
              lastSaleCost: lastSaleCost,
              qty: Number(this.qty),
            });
          }
          this.calcTotal();
          this.setLocalStorage();
          this.clearProduct();
        }
      }
      this.scrollToEnd();
    },
    editSale() {
      if (!this.isLoading) {
        if (this.sales[0].products.length > 0) {
          this.isLoading = true;
          this.sales[0].total_discount = this.sales[0].discount;
          this.sales[0].products.map(function (value) {
            value["pivot"]["qty"] = Number(value["pivot"]["new_qty"]);
          });
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل البيانات",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          axiosApi
            .put(`sales/${this.sales[0].id}`, this.sales[0])
            .then((response) => {
              this.invoice_details = response.data.invoice_details;
              localStorage.setItem(
                "sale_edited_invoice",
                JSON.stringify(response.data.invoice_details)
              );
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              setTimeout(() => {
                this.$router.push("/sales/report");
              }, 100);
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من كمية المنتج",
                  duration: 1500,
                });
                for (let i = 0; i < this.sales[0].products.length; i++) {
                  this.sales[0].products[i].pivot.old_qty =
                    err.response.data[0].products[i].pivot.qty -
                    err.response.data[0].products[i].pivot.returned_qty;
                }
                this.confirmEdit = false;
              }
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      }
    },
    calcTotal() {
      this.checkStock();
      let buy_cost = 0;
      let sale_total = 0;
      this.allowSale = true;
      var qty = 0;
      for (var i = 0; i < this.sales[0].products.length; i++) {
        if (
          this.sales[0].products[i].pivot.buy_cost >
          this.sales[0].products[i].pivot.sale_price
        ) {
          this.allowSale = false;
        }
        if (this.sales[0].products[i].pivot.qty == "") {
          this.sales[0].products[i].pivot.qty = 1;
        }
        let buy = Number(
          this.sales[0].products[i].pivot.new_qty *
            this.sales[0].products[i].pivot.buy_cost
        );
        buy_cost = buy_cost + buy;
        let sale = Number(
          this.sales[0].products[i].pivot.new_qty *
            this.sales[0].products[i].pivot.sale_price
        );
        sale_total = sale_total + sale;
        qty = qty + Number(this.sales[0].products[i].pivot.new_qty);
        this.checkQty();
        this.sales[0].total_buy_cost = Number(buy_cost);
        this.sales[0].total_sale_cost = Number(sale_total);
        this.sales[0].total_qty = Number(qty);
      }
      this.discountChange();
      this.setLocalStorage();
    },
    checkQty() {
      for (var i = 0; i < this.sales[0].products.length; i++) {
        this.sales[0].products[i].pivot.qty = Number(
          this.sales[0].products[i].pivot.qty
        );
        let qty = 0;
        if (
          Number(this.sales[0].products[i].pivot.qty) >=
          Number(this.sales[0].products[i].pivot.old_qty)
        ) {
          qty =
            Number(this.sales[0].products[i].pivot.new_qty) -
            Number(this.sales[0].products[i].pivot.old_qty);
        }
        if (qty > Number(this.sales[0].products[i].stock)) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (this.sales[0].products[i].pivot.qty == "") {
          this.sales[0].products[i].pivot.qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("edit_sales", JSON.stringify(this.sales));
    },
    clearProduct() {
      this.$refs.searchProductsComponent.setValue(null);
      this.qty = "";
      this.selectedProductStock = "-";
      this.selectedProductlastSaleCost = "-";
      this.sale_price = "";
      this.product = null;
      this.selectedUnit = null;
      this.selectedUnitId = null;
      this.productUnits = [];
      setTimeout(() => {
        document.querySelector(".productQuery input").focus();
      }, 100);
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    useBarcode() {
      if (this.useParcode) {
        document.querySelector(".parcodeSearch input[type='text']").focus();
      } else {
        document.querySelector(".productQuery input").focus();
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");
    },
    saveShortKey() {
      if (this.confirmEdit) {
        this.editSale();
      }
    },
    checkValidQty(item) {
      if (item.pivot.new_qty < item.pivot.old_qty) {
        item.showQtyToolTip = true;
      } else if (item.pivot.new_qty >= item.pivot.old_qty) {
        item.showQtyToolTip = false;
        this.calcTotal();
      }
    },
    accessLinks(link) {
      let permissionNames = JSON.parse(localStorage.getItem("permissionNames"));
      return permissionNames.includes(link);
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
.text-center {
  text-align: center !important;
}
</style>
